import {useStore} from './useStore';

export const useCustomersFilterCount = () : number => {
    const filters = useStore( store => store.ui.customers);

    let activeFilterCount = 0;
    if (filters.searchFilter) {
        activeFilterCount++;
    }

    return activeFilterCount;
}